var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlossary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-3cy68l",
    "aria-label": "book",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4V17 M19 17V21 M17 4H19C19.552 4 20 4.448 20 5V16C20 16.552 19.552 17 19 17H6C4.895 17 4 17.895 4 19V19C4 20.105 4.895 21 6 21H20 M4 19V6C4 4.895 4.895 4 6 4H13 M16 3H14C13.448 3 13 3.448 13 4V9L15 8L17 9V4C17 3.448 16.552 3 16 3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossary);
export default __webpack_public_path__ + "static/media/glossary.502bca8501fe6a8a25e7bd5f95ff3098.svg";
export { ForwardRef as ReactComponent };